import React from "react";
import { Box } from "@mui/material";
import colors from "../../../../theme/colors";
import "./GlobalCommunity.css";
import GlobalCommunityAnimation from "../animations/globalCommunityAnimation";
import GlobalCommunityUI from "./GlobalCommunityUI";

const GlobalCommunity = () => {
  return (
    <Box 
      component="section" 
      className="global-community-section" 
      sx={(theme) => ({ 
        backgroundColor: colors.home.navyDeep,
        pt: {
          xs: theme.custom.layoutSizes.mobileStandard.padding.topBottom,
          md: theme.custom.layoutSizes.section.paddingTop,
        },
        pb: {
          xs: theme.custom.layoutSizes.mobileStandard.padding.topBottom,
          md: theme.custom.layoutSizes.section.paddingBottom,
        },
        px: {
          ...theme.custom["home-section-left-padding"],
          xs: theme.custom.layoutSizes.mobileStandard.padding.leftRight,
        },
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        boxSizing: 'border-box'
      })}
    >
      <GlobalCommunityAnimation>
        <GlobalCommunityUI />
      </GlobalCommunityAnimation>
    </Box>
  );
};

export default GlobalCommunity;